import Router from '../router';
import {Component, Vue} from 'vue-property-decorator';

export interface Meta {
    pageNumber: number;
    totalResults: number;
    itemsPerPage: number;
    visiblePages: number;
    sort?: string;
    status?: string;
    query?: string;
    pid?: string;
    // DateFilter
    startDate?: string;
    endDate?: string;
    selectedDateOption?: string;
    // PartnerTypeFilters
    type?: string;
    // ServiceTypeFilters
    serviceTypes?: string[];
    cloudService?: boolean;
    mobileService?: boolean;
    mobileKpnService?: boolean;
    connectionService?: boolean;
    sipTrunkService?: boolean;
    // StatusFilters
    orderInProgress?: boolean;
    orderAccepted?: boolean;
    orderOnHold?: boolean;
    orderPlanned?: boolean;
    orderDelivered?: boolean;
    orderTerminationRequested?: boolean;
    orderTerminated?: boolean;
    orderDeclined?: boolean;
    // Misc
    showActiveProducts?: boolean;
    showDeletedProducts?: boolean;
    lastTableLoaded?: string;
}

interface ResponseMeta {
    startIndex: number;
    numberOfItems: number;

    // TODO Some endpoints return meta with totalNumberOfItems and others with totalItems
    totalNumberOfItems?: number;
    totalItems?: number;
}

@Component
export default class TableMixin extends Vue {
    // DATA
    // keepStateMeta is reset when clicking on header items
    public keepStateMeta: boolean = this.$store.getters.getLastLoadedTable === this.tableName()
      && this.$store.getters.getMeta[this.tableName()];

    public pageMeta: Meta = this.keepStateMeta ? this.$store.getters.getMeta[this.tableName()] : {
        pageNumber: 1,
        totalResults: 0,
        itemsPerPage: 25,
        visiblePages: 5,
        type: '',
        status: '',
        dql: '',
        sort: this.tableState ? this.tableState.sort : undefined,
        cloudService: false,
        mobileService: false,
        mobileKpnService: false,
        connectionService: false,
        hasComments: false,
    };

    public selectItemsPerPage: object = {
        title: 'Regels per pagina:',
        items: [
          '10',
          '25',
          '50',
          '100',
        ],
    };

    get tableState(): any {
        return this.$store.getters.getTableStates[this.tableName()];
    }

    get startIndex(): any {
        return ((this.pageMeta.pageNumber - 1) * this.pageMeta.itemsPerPage) || 0;
    }

    // PAGINATION / SORTING
    public columnClick(cell: any, click: any) {
        this.pageMeta.pageNumber = 1;
        this.pageMeta.sort = click + cell.dql + '';

        this.$store.commit('SET_TABLE_STATE', {
            name: this.tableName(),
            tableState: {
                sort: click + cell.dql + '',
            },
        });

        this.loadList(this.pageMeta);
    }

    public itemsPerPageChanged(itemsPerPage: number) {
        this.pageMeta.itemsPerPage = itemsPerPage;
        this.paginationChanged(1);
    }

    public paginationChanged(pageNumber: any) {
        this.pageMeta.pageNumber = pageNumber;
        this.loadList(this.pageMeta);
    }

    public setDefaultSort(sort: string): void {
        if (!this.tableState || !this.tableState.sort) {
            this.pageMeta.sort = sort;
        }
    }

    public keepMetaSavedInState(): void {
        this.$store.dispatch('setLastLoadedTable', this.tableName());
    }

    public updateMeta(responseMeta: ResponseMeta): void {
        this.pageMeta.pageNumber = (responseMeta.startIndex / responseMeta.numberOfItems) + 1;
        this.pageMeta.totalResults = responseMeta.totalNumberOfItems || responseMeta.totalItems || 0;

        this.$store.dispatch('addMeta', {name: this.tableName(), meta: this.pageMeta});
    }

    // ROUTE
    public sectionRoute(name: string, params?: {}): void {
        Router.push({name, params});
    }

    // ABSTRACT
    public tableName() {
        // Should be overwritten by component
        return 'UNTITLED_TABLES_WILL_BE_OVERWRITTEN';
    }

    public loadList(data: any): void {
        // Can't be abstract because Vue mixins don't support abstract mixins
        // Should be overwritten by component
    }
}
